module.exports = __webpack_public_path__ + "assets/img/icon2.a4aea694.svg";